import 'slick-carousel'
import $ from 'jquery'

$(document).ready(function () {
  $('.dhsv_vc_benefits_slider').each(function (idx, dhsvVcBenefitsSlider) {
    $('.benefits-slider__carousel').each(function (i, el) {
      if (!$(el).hasClass('slick-initialized')) {
        $(el).slick({
          fade: true,
          speed: 500,
          autoplay: true,
          autoplaySpeed: 5000,
        })
        let $nextSlide, $currentSlide
        $(el).on('beforeChange', function (
          event,
          slick,
          currentSlide,
          nextSlide
        ) {
          $nextSlide = $(`[data-slick-index="${nextSlide}"]`)
          $currentSlide = $(`[data-slick-index="${currentSlide}"]`)
          let isLastNext =
            currentSlide == slick.slideCount - 1 && nextSlide == 0
          let isLastPrev =
            currentSlide == 0 && nextSlide == slick.slideCount - 1
          // direction "true" means move to the right
          let direction =
            (currentSlide < nextSlide && !isLastPrev) || isLastNext
              ? 'next'
              : 'prev'
          $nextSlide
            .removeClass('out-next out-prev in-next in-prev')
            .addClass('in-' + direction)
          $currentSlide
            .removeClass('out-next out-prev in-next in-prev')
            .addClass('out-' + direction)
        })
        $(el).on('afterChange', function (/*event, slick, currentSlide*/) {
          $('.slick-slide').removeClass('out-next out-prev in-next in-prev')
          // $(`[data-slick-index="${currentSlide}"]`).addClass('current')
        })
      }

      /* global ajaxurl */
      $('.js-benefits-item', el).on('click', function () {
        $('.modal-text', dhsvVcBenefitsSlider).html(
          '<div class="spinner"></div>'
        )

        $.ajax({
          type: 'POST',
          url: ajaxurl.url,
          data: {
            post_id: $(this).data('post_id'),
            action: 'get_benefits_post_content', //this is the name of the AJAX method called in WordPress
          },
          success: function (result) {
            $('.modal-text', dhsvVcBenefitsSlider).html(result.result)
          },
          error: function () {
            console.log('error gettin the post') // eslint-disable-line
          },
        })

        const targeModal = $($(this).data('target'))
        const slideIndex = $(this).data('slide-index')
        const $slider = targeModal.find('.js-benefits-modal-slider')
        $slider.css({
          height: 0,
          opacity: 0,
        })

        targeModal.on('shown.bs.modal', function () {
          if ($slider.hasClass('slick-initialized')) {
            $slider.slick('unslick')
          }

          $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
            initialSlide: slideIndex,
          })

          $slider.css({
            height: 'auto',
            opacity: 1,
          })
        })

        targeModal.modal('show')
      })
    })
  })
})
